import { coalesce } from "@kazoohr/helpers";

import {
  DEFAULT_LANGUAGE,
  SUPPORTED_LANGUAGES,
  SupportedLanguage,
  isSupportedLanguage,
  matchLanguage,
} from "../../locales/supportedLanguages";

const STORAGE_KEY = "constellation_language";

let currentLanguage: SupportedLanguage | undefined;

export function getStoredLanguage(): SupportedLanguage | undefined {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return isSupportedLanguage(stored) ? stored : undefined;
  } catch {
    return undefined;
  }
}

export function storeLanguage(language: SupportedLanguage): void {
  try {
    localStorage.setItem(STORAGE_KEY, language);
  } catch {
    return;
  }
}

export function resolveInitialLanguage(
  browserLanguages: readonly string[] = navigator.languages
): SupportedLanguage {
  return coalesce(
    getStoredLanguage(),
    matchLanguage(browserLanguages, SUPPORTED_LANGUAGES, DEFAULT_LANGUAGE)
  );
}

export function setCurrentLanguage(language: SupportedLanguage): void {
  currentLanguage = language;
  document.documentElement.lang = language;
}

export function getCurrentLanguage(): SupportedLanguage {
  return coalesce(currentLanguage, resolveInitialLanguage());
}
